import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle } from "tabler-icons-react";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
	const { t } = useTranslation();

	return (
		<div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-6">
			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.6 }}
				className="flex flex-col items-center"
			>
				<AlertTriangle
					size={64}
					strokeWidth={1.5}
					className="text-[#43BD98] mb-6"
				/>
				<h1 className="text-3xl font-bold text-gray-800 mb-3">
					{t("notFound.title")}
				</h1>
				<p className="text-gray-600 max-w-md mb-8">
					{t("notFound.description")}
				</p>
				<a
					href="https://applaby.com"
					className="px-6 py-2 rounded-full font-semibold text-white shadow-md"
					style={{ backgroundColor: "#43BD98" }}
				>
					{t("notFound.backHome")}
				</a>
			</motion.div>
		</div>
	);
}
